import React from 'react';

function Home() {
  return (
    <header className="App-header">
      <p>
        We are cooking our site. Please comeback in a few days.
      </p>
    </header>
  );
}

export default Home;